import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import {
  GetMerkleProofDetailResponse,
  GetMerkleProofHistoryRequest,
  GetMerkleProofHistoryResponse,
  ProofOfReserves,
} from './types';

export const getProofOfReservesApi = (params: { auditTime?: string }) =>
  apiClient.get<ProofOfReserves>('/v1/proof-of-reserves', { params });

export const fetchProofOfReservesApi = () => fetchClient.fetch<ProofOfReserves>('/v1/proof-of-reserves');

export const getMerkleProofHistoryApi = (params: GetMerkleProofHistoryRequest) =>
  apiClient.get<GetMerkleProofHistoryResponse>('/v1/merkle-proof/history', { params });

export const getMerkleProofDetailApi = (verificationTimestamp: string) =>
  apiClient.get<GetMerkleProofDetailResponse>(`/v1/merkle-proof/history/${verificationTimestamp}`);
